import {useTranslation} from '@aboutyou/i18n';
import React, {FC} from 'react';
import styled, {css} from 'styled-components';
import {tabletAndUp} from '../../../../constants/customMedia';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../../constants/typography';

const desktopTitleFontSize = css`
  font-size: ${FONT_SIZES.px32};
`;

const BasketH2 = styled.h2`
  font-weight: ${FONT_WEIGHTS.heavy};
  font-size: ${FONT_SIZES.px20};

  ${tabletAndUp(desktopTitleFontSize)}
`;

/**
 * @deprecated This component is deprecated because it violates best practices defined in the @aboutyou/ui-components.
 * Do not take inspiration from this component for new implementations.
 */
export const BasketTitle: FC = () => {
  const {t} = useTranslation();
  return <BasketH2>{t('Basket')}</BasketH2>;
};

export const BasketPageTitlePrice = styled.span`
  direction: initial;
  font-weight: ${FONT_WEIGHTS.heavy};
  font-size: ${FONT_SIZES.px14};

  ${tabletAndUp(desktopTitleFontSize)}
`;
